import React from "react";
import { Modal } from "antd";
import NewTicketForm from "./NewTicketForm";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";

export default function NewTicketModal() {
  const general = useGeneralStore();
  const visible = general.view.newTicketModal;

  return (
    <div>
      <Modal
        width={800}
        title={"افزودن تیکت"}
        className="custom-table"
        visible={visible}
        footer={false}
        onCancel={() => general.ToggleNewTicketModal()}
      >
        <NewTicketForm
          onSubmit={() => {
            general.ToggleNewTicketModal();
          }}
        >
        </NewTicketForm>
      </Modal>
    </div>
  );
}
